import Validation from '../validation/Validation';
import ParameterErrors from '../errors/ParameterErrors';
import Vector3 from '../geometry/Vector3';
const { throwNotProvided, throwNotOfType } = ParameterErrors;
export default class Location {
    constructor(props) {
        const { position, rotation, scaling } = props;

        if (!position)
            throwNotProvided("position");
        if (!position instanceof Vector3)
            throwNotOfType("position", Vector3.constructor.name);
        this._position = position;


        if (!rotation)
            throwNotProvided("rotation");
        if (!rotation instanceof Vector3)
            throwNotOfType("rotation", Vector3.constructor.name);
        this._rotation = rotation;


        if (!scaling)
            throwNotProvided("scaling");
        if (!scaling instanceof Vector3)
            throwNotOfType("scaling", Vector3.constructor.name);
        this._scaling = scaling;
		this.toJSON = this.toJSON.bind(this);
    }
    get position() {
        return this._position;
    }
    get rotation() {
        return this._rotation;
    }
    get scaling() {
        return this._scaling;
    }
	toJSON(){
		return {
			position:this._position.toArray(), 
			rotation:this._rotation.toArray(), 
			scaling:this._scaling.toArray()
		};
	}
    static fromJSON(obj) {
        return new Location({
            position: Vector3.fromArray(obj.position),
            rotation: Vector3.fromArray(obj.rotation),
            scaling: Vector3.fromArray(obj.scaling)
        })
    }
	static getDefault(){
        return new Location({
            position: Vector3.fromArray([0,0,0]),
            rotation: Vector3.fromArray([0,0,0]),
            scaling: Vector3.fromArray([1,1,1])
        })
	}
}
